import { render, staticRenderFns } from "./reportTotal.vue?vue&type=template&id=170bf996"
import script from "./reportTotal.vue?vue&type=script&lang=js"
export * from "./reportTotal.vue?vue&type=script&lang=js"
import style0 from "./reportTotal.vue?vue&type=style&index=0&id=170bf996&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports